export const WORKKEYS_REPLACE_TERMS = {
  school: "institution",
  schools: "institutions",
  "school district": "institution",
  "school districts": "institutions",
  "school admin": "institution admin",
  "school admins": "institution admins",

  teacher: "instructor",
  teachers: "instructors",

  student: "learner",
  students: "learners",

  masteryprep: "ACT WorkKeys Curriculum", // MasteryPrep: "ACT WorkKeys Curriculum"

  practice_test: "quiz",
  "practice test": "quiz", // For display labels
  diagnostic_test: "Diagnostic",
  mastery_lesson: "lesson",

  "current school year": "Current Institution Year",
  "last school year": "Last Institution Year"
}

export const WORKKEYS_REPLACE_FILTER_KEYS = {
  school: "institution",
  teacher: "instructor",
  student: "learner"
}

export const WORKKEYS_REPLACE_SEARCH_PARAMS = {
  institution: "school",
  instructor: "teacher",
  learner: "student"
}

export const WORKKEYS_REPLACE_URL_SUBPAGE = {
  schools: "institutions",
  teachers: "instructors",
  students: "learners",
  "students-usage": "learners-usage"
}

export const WORKKEYS_REPLACE_URL_CONTENT_TYPE = {
  "practice-test": "quiz",
  "mastery-lesson": "online-lesson",
  "downloadable-resource": "digital-resource"
}

export const WORKKEYS_REPLACE_URL_CONTENT_TYPE_REVERSE = {
  quiz: "practice-test",
  "online-lesson": "mastery-lesson",
  "digital-resource": "downloadable-resource"
}

export const WORKKEYS_REPLACE_QUERY_CONTENT_TYPE = {
  practice_test: "quiz",
  mastery_lesson: "online_lesson",
  downloadable_resource: "digital_resource"
}

// Reverse mapping for reading from URL
export const WORKKEYS_REPLACE_QUERY_CONTENT_TYPE_REVERSE = {
  quiz: "practice_test",
  online_lesson: "mastery_lesson",
  digital_resource: "downloadable_resource"
}
